import { TASK_LIST } from './types';

export const setTaskListErrorMessage = (payload) => {
  return {
    type: TASK_LIST.SET_ERROR_MESSAGE,
    payload
  };
};

export const setTaskListYear = (payload) => {
  return {
    type: TASK_LIST.SET_YEAR,
    payload
  };
};

export const setTaskListShowAll = (payload) => {
  return {
    type: TASK_LIST.SET_SHOW_ALL,
    payload
  };
};

export const setTaskListOrder = (payload) => {
  return {
    type: TASK_LIST.SET_ORDER,
    payload
  };
};

export const setBulkEditMode = (payload) => {
  return {
    type: TASK_LIST.SET_BULK_EDIT_MODE,
    payload
  };
};

export const setBulkEditTasks = (payload) => {
  return {
    type: TASK_LIST.SET_BULK_EDIT_TASKS,
    payload
  };
};

export const setTaskListFilters = (payload) => {
  return {
    type: TASK_LIST.SET_FILTERS,
    payload
  };
};

export const setTaskListCurrentTab = (payload) => {
  return {
    type: TASK_LIST.SET_CURRENT_TAB,
    payload
  };
};

export const setTaskListPageNumber = (payload) => {
  return {
    type: TASK_LIST.SET_PAGE_NUMBER,
    payload
  };
};
